import DatabaseReference from '../platform/DatabaseReference';
import Trip from './Trip';

export default class TripsAll extends DatabaseReference {
  get childReferenceType() {
    return Trip;
  }
}
